var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-background",attrs:{"id":"loginError"}},[_c('div',{staticClass:"modal-content pop-02"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.hideModal('loginError')}}}),_c('h4',[_vm._v(_vm._s(_vm.body))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }